import React from "react";
import withSearch from "./withSearch";

function WithSearch(_ref) {
  var mapContextToProps = _ref.mapContextToProps,
      children = _ref.children;
  var Search = withSearch(mapContextToProps)(function (props) {
    return children(props);
  });
  return /*#__PURE__*/React.createElement(Search, null);
}

export default WithSearch;